import { render } from "./PollockApp.vue?vue&type=template&id=10c9f1fc"
import script from "./PollockApp.vue?vue&type=script&lang=js"
export * from "./PollockApp.vue?vue&type=script&lang=js"

import "./PollockApp.vue?vue&type=style&index=0&id=10c9f1fc&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__